export default {"src":"/_next/static/media/illustration-rations.aca659c6.svg","height":99,"width":86};